import { adminApi, userApi, sellerApi, riderApi } from "./api";

function getCallerApi(role) {
  if (role === "seller") return sellerApi;
  if (role === "rider") return riderApi;
  if (role === "user") return userApi;
  if (localStorage.getItem("seller_token")) return sellerApi;
  if (localStorage.getItem("rider_token")) return riderApi;
  return userApi;
}

export const getCommissionLevelsApi = async () => {
  const res = await adminApi.get("/api/v1/commissions/levels");
  return res.data;
};

export const createCommissionLevelApi = async (data) => {
  const res = await adminApi.post("/api/v1/commissions/levels", data);
  return res.data;
};

export const updateCommissionLevelApi = async (id, data) => {
  const res = await adminApi.put(`/api/v1/commissions/levels/${id}`, data);
  return res.data;
};

export const deleteCommissionLevelApi = async (id) => {
  const res = await adminApi.delete(`/api/v1/commissions/levels/${id}`);
  return res.data;
};

export const updateCommissionLevelOrderApi = async (levelOrders) => {
  const res = await adminApi.put("/api/v1/commissions/levels/order", { levelOrders });
  return res.data;
};

export const getCommissionPaymentsApi = async (params = {}) => {
  const queryParams = {
    limit: params.limit || 10,
    offset: params.offset || 0,
    status: params.status || null,
  };
  
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key] === null || queryParams[key] === "") {
      delete queryParams[key];
    }
  });
  
  const res = await adminApi.get("/api/v1/commissions/payments", {
    params: queryParams,
  });
  return res.data;
};

export const processCommissionPaymentApi = async (paymentId) => {
  const res = await adminApi.post(`/api/v1/commissions/payments/${paymentId}/process`);
  return res.data;
};

export const createCommissionPackApi = async (data) => {
  const res = await adminApi.post("/api/v1/commission/create", data);
  return res.data;
};

export const getCommissionPacksApi = async () => {
  const res = await adminApi.get("/api/v1/commission/list");
  return res.data;
};

export const updateCommissionPackApi = async (data) => {
  const res = await adminApi.put(`/api/v1/commission/update`, data);
  return res.data;
};

/** จำลองค่าคอมจากผู้ซื้อ + รายการสินค้า (ไม่บันทึกลง DB) */
export const simulateCommissionApi = async (data) => {
  const res = await adminApi.post("/api/v1/commission/simulate", data);
  return res.data;
};

/** ดึงรายชื่อแพ็คทั้งหมด (สำหรับ user / seller / rider) */
export const getPublicPacksApi = async (role) => {
  const res = await getCallerApi(role).get("/api/v1/commission/public");
  return res.data;
};

/** ซื้อ / เปลี่ยนแพ็คคอมมิชชัน */
export const buyCommissionPackApi = async (packId, role) => {
  const res = await getCallerApi(role).post("/api/v1/commission/buy", { packId });
  return res.data;
};

/** ดึง downline ของ user/seller/rider ปัจจุบัน */
export const getMyDownlineApi = async (role) => {
  const res = await getCallerApi(role).get("/api/v1/commission/my-downline");
  return res.data;
};
